import { render, staticRenderFns } from "./CampoDeCpfOuCnpjOculto.vue?vue&type=template&id=11af3cc7&"
import script from "./CampoDeCpfOuCnpjOculto.vue?vue&type=script&lang=ts&"
export * from "./CampoDeCpfOuCnpjOculto.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
